import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getOurGraduates, homeSelect } from 'redux-api/slices/HomeSlice';
import { REQUEST_STATUSES } from 'common/constants';
import bubble from 'assets/icons/home/hmBubble.svg';
import classes from './HomeGraduates.module.scss';
import HomeSlider from './HomeSlider';


const HomeGraduates = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { studentGraduates, studentGraduatesStatus } = useSelector(homeSelect);

  useEffect(() => {
    dispatch(getOurGraduates());
    return () => null;
  }, [ dispatch ]);

  if (studentGraduatesStatus !== REQUEST_STATUSES.SUCCEEDED || !studentGraduates?.length) return null;

  return (
    <section className={classes.graduates}>
      <div className={classes.container}>
        <HomeSlider title={t('OUR_GRADUATES')} trackClass={classes.track} slideClass={classes.slide}>
          {studentGraduates.map((item, i) => (
            <article
              className={classes.card}
              key={item.name ?? i}
              data-aos="fade-up"
              data-aos-delay={(i % 3) * 100}
            >
              {/* Облако с «хвостиком» — цельная фигура из макета. */}
              <div className={classes.bubble}>
                <img className={classes.bubbleShape} src={bubble} alt="" />
                <p className={classes.text}>{item.text}</p>
              </div>

              <div className={classes.person}>
                <img className={classes.avatar} src={item.image} alt={item.image_alt || item.name} />
                <div className={classes.personText}>
                  <p className={classes.name}>
                    {item.name}
                    <br />
                    {item.age}
                  </p>
                  <p className={classes.position}>{item.position}</p>
                </div>
              </div>
            </article>
          ))}
        </HomeSlider>
      </div>
    </section>
  );
};

export default HomeGraduates;
